import { FluentResultError } from '../types';

export function isFluentResultError(data: unknown): data is FluentResultError[] {
    return (
        Array.isArray(data) &&
        data.every(
            (item) => typeof item === 'object' && item !== null && ('message' in item || 'reasons' in item || 'metadata' in item), // At least one key must exist
        )
    );
}
